var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2004 1.2C10.201 1.99535 9.97578 2.77452 9.55091 3.44688C9.12604 4.11924 8.51899 4.65714 7.80039 4.998L7.80039 7.002C8.51899 7.34286 9.12604 7.88076 9.55091 8.55312C9.97578 9.22548 10.201 10.0047 10.2004 10.8L11.4004 10.8L11.4004 12L0.600391 12L0.600391 10.8L1.80039 10.8C1.79977 10.0047 2.025 9.22548 2.44987 8.55312C2.87474 7.88076 3.48179 7.34286 4.20039 7.002L4.20039 4.998C3.48179 4.65714 2.87474 4.11924 2.44987 3.44688C2.025 2.77452 1.79977 1.99535 1.80039 1.2L0.60039 1.2L0.60039 9.44166e-07L11.4004 0L11.4004 1.2L10.2004 1.2ZM9.00039 10.8C9.00053 10.1084 8.76172 9.43801 8.32437 8.90226C7.88703 8.36651 7.27801 7.99832 6.60039 7.86L6.60039 6L5.40039 6L5.40039 7.86C4.72277 7.99832 4.11375 8.36651 3.67641 8.90226C3.23906 9.43801 3.00025 10.1084 3.00039 10.8L9.00039 10.8Z",
    fill: "#F48A0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitIcon);
export default __webpack_public_path__ + "static/media/waitIcon.d69291ce2bb9a274879ee2d4156851e0.svg";
export { ForwardRef as ReactComponent };